module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_9016.b9c139f5.png";